// extracted by mini-css-extract-plugin
export default {"root":"lgViL","item":"M2kxH","amount":"SlgWE","active":"Q24W1","coin":"Jewfb","lottieCoins":"dP7Fu"};